import { env } from "@saas/config/shared/env/env";
import { ResponseInterface } from "@saas/core/^interface/response/response.interface";
import { fetchJson } from "@saas/core/fetch/fetch-json/fetch-json";
import { mapToCamelCase } from "@saas/shared/utils/map-to-camel-case/map-to-camel-case";
import { mapToSnakeCase } from "@saas/shared/utils/map-to-snake-case/map-to-snake-case";

export type TPostMetadataRecoveryInput = {
  email: string;
  recoveryFrom: string;
};

export type TPostMetadataRecoveryOutput = {
  message: string;
  statusCode: number;
};

export const postMetadataRecovery = async (
  input: TPostMetadataRecoveryInput,
  options?: RequestInit
): Promise<TPostMetadataRecoveryOutput> => {
  const response = await fetchJson<ResponseInterface>(
    "/api/promotion/internal/user-accounts/metadata/recovery",
    {
      ...options,
      headers: {
        ...options?.headers,
        Authorization: `Basic ${Buffer.from(
          `${env.MARKETING_PROMOTION_SERVICE_USERNAME}:${env.MARKETING_PROMOTION_SERVICE_PASSWORD}`
        ).toString("base64")}`,
      },
      method: "POST",
      body: JSON.stringify(mapToSnakeCase(input)),
    }
  );

  return mapToCamelCase(response);
};
